import { render, staticRenderFns } from "./GiveDiscount.vue?vue&type=template&id=db1003bc&scoped=true"
import script from "./GiveDiscount.vue?vue&type=script&lang=js"
export * from "./GiveDiscount.vue?vue&type=script&lang=js"
import style0 from "./GiveDiscount.vue?vue&type=style&index=0&id=db1003bc&prod&lang=scss&scoped=true"
import style1 from "./GiveDiscount.vue?vue&type=style&index=1&id=db1003bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1003bc",
  null
  
)

export default component.exports